module.exports = __webpack_public_path__ + "static/media/i82.e15d6601.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i82.svg
// module id = 154
// module chunks = 12